import { getTicketingBaseUrl } from '@/utils/domainUrls'
import {
	ENABLE_TICKETING_PAYMENT_TYPE_QUERY_BRIDGE,
	TICKETING_PAYMENT_TYPE_QUERY_KEY,
	normalizeTicketingPaymentType
} from '@/ticketingPaymentTypeQueryBridge'

export default {
	methods: {
		async goToProducts(extraQuery = {}) {
			const query = {
				...this.$route.query,
				...extraQuery
			}
			const params = query.category ? { category: query.category } : {}
			const hasExtraQuery = Object.keys(extraQuery).length > 0
			if (query.category) {
				delete query.category

				if (query.productId) {
					delete query.productId
				}

				const routerData = {
					name: 'products-category',
					params,
					query
				}

				await this.$router.push(routerData)

				return
			}

			await this.$router.push(
				hasExtraQuery
					? { name: 'products', query: extraQuery }
					: { name: 'products' }
			)
		},

		async goToCheck() {
			const { query, params } = this.$route

			const newQuery = { ...query }

			if (params.category) newQuery.category = params.category

			if (newQuery.eventTicketId) delete newQuery.eventTicketId

			await this.$router.push({
				name: 'check',
				query: newQuery
			})
		},

		async goToProcessing() {
			const { query, params } = this.$route

			if (params.eventTicketId) {
				query.eventTicketId = params.eventTicketId
			}

			await this.$router.push({ name: 'processing', query, params })
		},

		async goToToEventTicketTab(eventTicketId, paymentType = '') {
			const query = {}

			if (ENABLE_TICKETING_PAYMENT_TYPE_QUERY_BRIDGE) {
				const normalizedPaymentType = normalizeTicketingPaymentType(
					paymentType || this.$route?.query?.[TICKETING_PAYMENT_TYPE_QUERY_KEY]
				)

				if (normalizedPaymentType) {
					query[TICKETING_PAYMENT_TYPE_QUERY_KEY] = normalizedPaymentType
				}
			}

			await this.$router.push({
				name: 'payment-method',
				params: { eventTicketId },
				query
			})
		},

		getTicketingBaseUrl() {
			const baseUrl = getTicketingBaseUrl(this.venueInfo, this.$route.params)

			if (!baseUrl) {
				return ''
			}

			return baseUrl.replace(/\/$/, '')
		},

		goToTicketingOrder(orderId) {
			const baseUrl = this.getTicketingBaseUrl()

			if (!baseUrl) {
				return
			}

			window.location.href = `${baseUrl}/order/${orderId}`
		},

		goToTicketingEvents() {
			const baseUrl = this.getTicketingBaseUrl()

			if (!baseUrl) {
				return
			}

			window.location.href = `${baseUrl}/events`
		}
	}
}
